@use '@styles/variables' as *;

// The one orange button. Every filled orange CTA renders through this class,
// so a hover only has to be right here. antd repaints the border and the
// shadow of a default button on hover, hence the !important on those.
.orangeButton {
  align-items: center;
  background-color: $v2-secondary-400;
  border: none;
  border-radius: 10px;
  box-shadow: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  height: 48px;
  justify-content: center;
  padding: 10px 20px;
  transition: background-color 0.2s ease;
  width: 100%;

  // Opt out via the fullWidth={false} prop instead of an !important width
  // override at the call site — every existing usage keeps the width: 100%
  // default untouched.
  &--auto {
    width: auto;
  }

  .ant-btn {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: $v2-secondary-500 !important;
    border: none !important;
    box-shadow: none !important;
    color: #fff !important;
  }

  &:focus-visible {
    outline: 2px solid $v2-primary-500;
    outline-offset: 2px;
  }

  &:disabled {
    background-color: $v2-secondary-300 !important;
    border: none !important;
    color: #fff !important;
    cursor: not-allowed;
  }
}
